/**
 * Forge test-channel tenant id (ADR-023 Phase 1).
 *
 * A forge's test build is served through the production plugin render path
 * (`/a/<archeId>?channel=test`), but the plugin bridge must NOT act as the
 * production arche: DataStore rows, sandbox storage and workspaces of a test
 * build live under a synthetic tenant, exactly like the Arche Builder's
 * `preview_<sessionId>` tenant. The host constructs `PluginBridgeHost` with
 * this id as `archId`, and the test-channel bridge token's `arche` claim IS
 * this id, so `verifyBridgeToken(token, expectedArcheId)` is unchanged.
 *
 * Mirrors `TEST_TENANT_PREFIX` / `testTenantIdForArche` in
 * `packages/db-types/src/forge.ts`. `@fias/webapp-client` deliberately does
 * not depend on `@fias/db-types`, so the helper is duplicated here and pinned
 * by `test-tenant.test.ts`, which reads the canonical source.
 */
export const TEST_TENANT_PREFIX = 'test_';

export function testTenantIdForArche(archeId: string): string {
  return `${TEST_TENANT_PREFIX}${archeId}`;
}

/** The one channel value the platform accepts besides production (absent). */
export type ArcheChannel = 'test';

/**
 * Reads the Forge test channel from a location's query string. Only the
 * literal `channel=test` counts — the server rejects any other value, so the
 * client never forwards one.
 */
export function readArcheChannel(search: string | undefined | null): ArcheChannel | undefined {
  return new URLSearchParams(search ?? '').get('channel') === 'test' ? 'test' : undefined;
}
